// src/Redux/Slices/backlogSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { fetchBacklogData } from "../Thunks/backlogThunk";
import { addAsyncResourceThunk } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const backlogSlice = createSlice({
  name: "backlog",
  initialState,
  reducers: {
    clearBacklog: (state) => {
      state.data = null;
      state.error = null;
    },

    updateBacklogIssueStatus: (state, action) => {
      const { issueId, newStatus } = action.payload;

      if (state.data?.list) {
        const issue = state.data.list.find((i) => i.id === issueId);
        if (issue) {
          issue.status = newStatus;
        }
      }
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchBacklogData);
  },
});

export const { clearBacklog, updateBacklogIssueStatus } = backlogSlice.actions;

// Selectors
export const selectBacklogData = (state) => state.backlog.data;
export const selectBacklogLoading = (state) => state.backlog.loading;
export const selectBacklogError = (state) => state.backlog.error;

export default backlogSlice.reducer;
